import Banner from "../Allcomponent/Banner"
import Cards from "../Allcomponent/cards"
import Contact from "../Allcomponent/contact"
function ContactUS(){
    return(
        <>
        <Banner/>
        <Cards/>
        <Contact/>
        </>
    )
}
export default ContactUS